import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-mx-auto" }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.menuManagement.roles')), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: _ctx.rolesListFiltered,
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
        selection: _ctx.selectedRoles,
        "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedRoles = $event)),
        class: "p-datatable-sm kn-table",
        dataKey: "id",
        responsiveLayout: "stack",
        breakpoint: "960px",
        onRowSelect: _ctx.onRowSelect,
        onRowUnselect: _ctx.onRowUnselect,
        onRowSelectAll: _ctx.onAllRowSelectionChange,
        onRowUnselectAll: _ctx.onAllRowSelectionChange
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        header: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                placeholder: _ctx.$t('common.search'),
                badge: "0",
                "data-test": "search-input"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            dataKey: "id",
            style: {"width":"50px"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: _ctx.$t('common.name')
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "filters", "selection", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnselectAll"])
    ]),
    _: 1
  }))
}